<template>
    <div class="list" @click="toLibraryInfo(libraryInfo.libId,libraryInfo.libCode,libraryInfo.libName,libraryInfo.libLevel,libraryInfo.logo,libraryInfo.websiteUrl)">
        <div class="se_left l">
            <img  :src="imgPath+libraryInfo.logo" :onerror="error">
        </div>
        <div class="se_right l">
            <p class="se_title ellip" :hover="libraryInfo.libName">{{libraryInfo.libName}}</p>
            <!--<p class="se_item ellip" v-if="libraryInfo.bookNum!=undefined">藏书量:{{Number(libraryInfo.bookNum)>10000?(Number(libraryInfo.bookNum)/10000).toFixed(1)+'万':libraryInfo.bookNum}}</p>-->
            <!--<p class="se_item ellip" v-if="libraryInfo.ebookNum!=undefined">电子书量:{{Number(libraryInfo.ebookNum)>10000?(Number(libraryInfo.ebookNum)/10000).toFixed(1)+'万':libraryInfo.ebookNum}}</p>-->
            <p class="se_item ellip" v-if="libraryInfo.bookNum!=undefined">纸质藏书:{{Number(libraryInfo.bookNum)-Number(libraryInfo.ebookNum)}}</p>
            <p class="se_item ellip" v-if="libraryInfo.ebookNum!=undefined">电子藏书:{{libraryInfo.ebookNum}}</p>
            <p class="se_item ellip">地址:{{libraryInfo.address}}</p>
        </div>
    </div>
</template>

<script>
  import {store} from '../../src/store/store.js';
  import {imgPath} from "../common/config";
  export default {
    name: "branchLibraryItem",
    data(){
      return {
        imgPath: imgPath,
        error: store.imgError_library,
      }

    },
    props:['libraryInfo'],
    methods:{
      toLibraryInfo(libId, libCode, libName, libLevel, logo,websiteUrl){
        this.$emit('toDetail',libId, libCode, libName, libLevel, logo,websiteUrl)
      },
    }
  }
</script>

<style scoped lang="sass">
        .list
            width: 300px
            height: 120px
            border: 1px solid #eee
            margin-right: 20px
            cursor: pointer
            box-sizing: border-box
            float: left
            margin-bottom: 60px
            &:nth-of-type(3n)
                margin-right: 0
            .se_left
                width: 120px
                height: 120px
                padding-top: 18px
                padding-left: 14px
                img
                    width: 92px
                    height: 85px
            .se_right
                width: 178px
                height: 120px
                border-left: 1px solid #eee
                padding: 14px 16px 17px 10px
                .se_title
                    font-size: 16px
                    color: #333333
                    margin-bottom: 4px
                .se_item
                    font-size: 12px
                    color: #000000
                    line-height: 24px
</style>
